import { h, Fragment } from 'preact';
import type { WPConfig } from '../../types';
import TextInput from '../inputs/TextInput';
import { purifyHTML } from '../../lib/purify';

const Personal = ({
	config,
}:{
	config: WPConfig;
}) => (
	<Fragment>
		<div className="ea-field-group ea-field-group-row">
			<TextInput
				name="FirstName"
				label={config.form.FirstName.label}
				placeholder={config.form.FirstName.placeholder}
			/>
			<TextInput
				name="LastName"
				label={config.form.LastName.label}
				placeholder={config.form.LastName.placeholder}
			/>
		</div>
		<div className="ea-field-group">
			<TextInput
				name="EmailAddress"
				label={config.form.EmailAddress.label}
				placeholder={config.form.EmailAddress.placeholder}
			/>
		</div>
		<div className="ea-field-group ea-field-group-row">
			<TextInput
				name="Occupation"
				label={config.form.Occupation.label}
				placeholder={config.form.Occupation.placeholder}
			/>
			<TextInput
				name="Employer"
				label={config.form.Employer.label}
				placeholder={config.form.Employer.placeholder}
			/>
		</div>
		{config.occupation_terms && (
			<div
				className="ea-terms-of-service ea-xsmall"
				dangerouslySetInnerHTML={{ __html: purifyHTML(config.occupation_terms) }}
			/>
		)}
	</Fragment>
);

export default Personal;
